import { render, staticRenderFns } from "./LoginTps.vue?vue&type=template&id=30de88dc"
import script from "./LoginTps.vue?vue&type=script&lang=js"
export * from "./LoginTps.vue?vue&type=script&lang=js"
import style0 from "./LoginTps.vue?vue&type=style&index=0&id=30de88dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports